var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"overflow-auto",attrs:{"max-width":"18rem","max-height":"25rem"}},[_c(_setup.ChemPropsWithCopyCard,{attrs:{"chemical":_vm.chemical ?? _vm.params?.data?.chemical,"props-to-show":['casrn', 'inchiKey'],"key-value-stacked":"","truncate-props":"","show-links":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }